
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Customer } from '../../../../models/Customer';
import { getRegisteredCustomers, setEntraUserEnabledState } from '../../../../state/customer/customer.actions';
import { selectRegisteredCustomers } from '../../../../state/customer/customer.selector';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CustomerState } from '../../../../state/customer/customer.reducer';
import { PageHeaderComponent } from '../../../page-header/page-header.component';

@Component({
  selector: 'app-manage-customers',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule, MatTooltipModule, RouterModule, PageHeaderComponent],
  templateUrl: './manage-customers.component.html',
  styleUrl: './manage-customers.component.css',
})
export class ManageCustomersComponent implements OnInit {
  customers$: Observable<Customer[] | null>;
  displayedColumns: string[] = ['reflexCustomerNo', 'name', 'email', 'isActive', 'actions'];

  constructor(private customerStore: Store<{ customer: CustomerState }>, private router: Router) {
    this.customers$ = this.customerStore.select(selectRegisteredCustomers);
  }

  ngOnInit(): void {
    this.customerStore.dispatch(getRegisteredCustomers());
  }

  toggleActivation(customer: Customer): void {
    this.customerStore.dispatch(setEntraUserEnabledState({ 
      customerId: customer.id, 
      action: customer.isActive ? 'disable' : 'enable' 
    }));
  }

  goToCustomer(customer: Customer): void {
    this.router.navigate(['/admin/customers/details', customer.reflexCustomerNo]);
  }
}
